export enum OGCFileFormatEnum {
  Shapefile = 'Shapefile',
  GeoJSON = 'GeoJSON',
  KML = 'KML',
}
